export default "__VITE_ASSET__wRPwLJdg__"